import { createContext, useContext, useEffect, useState } from "react";
import { api, setStoredToken } from "../lib/api";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tenant, setTenant] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    api.get("/tenant/config").then((r) => setTenant(r.data)).catch(() => {});
  }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setStoredToken(null);
    setUser(null);
    window.location.href = "/";
  };

  return (
    <UserContext.Provider value={{ user, tenant, loading, refresh, logout }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
